import getRole from './getRole';
import { ROLE, ROLE_OPTIONS } from '../constants';
import type { Role, SelectOption } from '../types/common';

/**
 * ユーザが持っているロール（Role[]）からRoleOptionを作成する。
 * 例）['user', 'admin'] -> { label: 'admin', value: ['admin']}
 * @param [Role[]]
 * @returns [SelectOption<Role[]>]
 */
const getRoleOption = (roles: Role[]): SelectOption<Role[]> | undefined => {
  const role: Role = getRole(roles);

  // チェック内容に応じたオプションを返す
  if (role === ROLE.USER) {
    return ROLE_OPTIONS.USER;
  } else if (role === ROLE.POWERUSER) {
    return ROLE_OPTIONS.POWERUSER;
  } else if (role === ROLE.ADMIN) {
    return ROLE_OPTIONS.ADMIN;
  } else if (role === ROLE.MAINTENANCE_ADMIN) {
    return ROLE_OPTIONS.MAINTENANCE_ADMIN;
  } else {
    return undefined;
  }
};

export default getRoleOption;
